export const plate = /[a-zA-z]{3}[0-9][0-9a-zA-Z][0-9]{2}/;
